import React from 'react'

import ToushiDuctable from "../images/Toushi Ductable.jpg";
import HATConcealedSplits from "../images/HAT Concealed Splits.jpg";

import Hitachiac from "../images/hitachi_banner.jpg";
import FlexiSplitAirConditioner from "../images/Flexi Split Air Conditioner.jpg";



function Hitachi() {
  return (
    <div>
  

      <img src={Hitachiac} className="d-block w-100" alt="Hitachiac_krishnagar" />
      <br />
      <div className="album py-1 ">

        <div className="container mt-2">
          <center>
            <h3 className='mb-3' style={{ color: "grey" }}><b>Air Conditioning Systems</b></h3>
            <h5>Cassette Air Conditioners
Cassette AC is ideal for large open-plan homes with a false ceiling plenum. Installed in the ceiling center, it distributes air evenly in all directions or selectively, based on user preferences.</h5>
          </center>
          <br />
        </div>
      </div>

      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={ToushiDuctable} className="card-img-top" alt="Toushi Ductable" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">Toushi Ductable</h5>
                  <p className="card-text describe mb-2"><small>Ductable Fixed Speed Cooling Only Split System
</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={FlexiSplitAirConditioner} className="card-img-top" alt="FlexiSplitAirConditioner"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> FlexiSplit Air Conditioner</h5>
                  <p className="card-text mb-2"><small>
                    Light Commercial Fixed Speed Cooling Only Split System</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>
              <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={HATConcealedSplits} className="card-img-top" alt="HATConcealedSplits"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> City Multi VRF System</h5>
                  <p className="card-text mb-2"><small>Light Commercial Concealed Inverter Cooling Only Split System</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>

             








          </div>
        </div>
      </div>
      <br />

    </div>
  )
}

export default Hitachi